"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const fetchData_1 = __importDefault(require("./fetchData"));
function useFetch(endPoint, method = 'GET', bodyDefault = {}, queryDefault = {}, baseApiUrl, defaultHeaders, defaultSuccessFunction, defaultErrorFunction, useFetchConfig) {
    const [data, setData] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)();
    const execute = (0, react_1.useCallback)((data, headers) => {
        setLoading(true);
        setData(undefined);
        setError(undefined);
        const [url, body] = bodyRefactoring(endPoint, data, bodyDefault, queryDefault);
        const finalUrl = `${baseApiUrl}/${url}`;
        const finalHeaders = Object.assign(Object.assign({}, defaultHeaders), headers);
        return new Promise((resolve, reject) => {
            (0, fetchData_1.default)(finalUrl, body, method, finalHeaders, defaultSuccessFunction, defaultErrorFunction)
                .then((d) => {
                setData(d);
                if (useFetchConfig.promiseResolve) {
                    resolve(d);
                }
                setLoading(false);
                return;
            })
                .catch((err) => {
                setError(err);
                if (useFetchConfig.promiseReject) {
                    reject(err);
                }
                setLoading(false);
                return;
            });
        });
    }, []);
    return [loading, execute, data, error];
}
function bodyRefactoring(url, data, bodyDefault, queryDefault) {
    let body = bodyDefault;
    let query = '?';
    for (const key in data) {
        const value = data[key];
        if (key in body) {
            body[key] = value;
        }
        else if (typeof value === 'undefined') {
            continue;
        }
        else if (key in queryDefault) {
            query = query.concat(`${key}=${value}&`);
        }
        else if (url.includes(`:${key}`)) {
            url = url.replace(`:${key}`, value);
        }
        else {
            throw new Error(`key: ${key} has no corresponding data type`);
        }
    }
    query = query.substring(0, query.length - 1);
    const bodyLength = Object.keys(body).length;
    if (bodyLength === 0) {
        body = undefined;
    }
    return [url.concat(query), body];
}
exports.default = useFetch;
//# sourceMappingURL=useFetch.js.map